const mergeNumericObjects = (object1, object2) => {
  const result = {};

  Object.keys(object1).forEach((item) => {
    if (!(item in result)) result[item] = 0;
    result[item] += object1[item];
  });

  Object.keys(object2).forEach((item) => {
    if (!(item in result)) result[item] = 0;
    result[item] += object2[item];
  });

  return result;
};

export default mergeNumericObjects;



// WEBPACK FOOTER //
// ./src/helpers/mergeNumericObjects.js